import React, { useMemo } from "react";
import PickerInput, { PickerPropsWithoutOptions } from "../inputs/PickerInput";

interface Props extends PickerPropsWithoutOptions { }

export default function CallTypePicker({ ...PickerProps }: Props) {

    const values: string[] = ['BizPro - Group Leader', 'GoSmallBiz', 'Legal', 'Miscellaneous', 'Services Inquiry', 'Toolkit', 'Upnetic'];

    const options = useMemo(() => values.map(c => ({ id: c, label: c })), [values]);

    return <PickerInput label={'Call Type'} options={options} {...PickerProps} />
}